module.exports = __webpack_public_path__ + "static/media/xiaoxueIcon.ba86f468.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/xiaoxueIcon.png
// module id = 691
// module chunks = 0 1